import { useMutation } from 'react-query';
import { sharedWorkflowService } from 'api/services';
import { useSiteDetection } from 'shared/hooks';
import { MappedWorkflowNode } from '../components/workflow-editor/mappers/map-canvas-content.types';

type Payload = {
  workflowName: string;
  graphData: MappedWorkflowNode[];
};

export const useCreateWorkflow = () => {
  const { site } = useSiteDetection();

  const mutationFn = async (payload: Payload) => {
    return await sharedWorkflowService.createWorkflow(
      site,
      payload.workflowName,
      payload.graphData
    );
  };

  return useMutation({ mutationFn });
};
